import { InjectableClass } from '@fino/lib-injection';

const ModalTypes = {
  Html: 'html',
  Url: 'url'
}

export class UiModalDeclarationService extends InjectableClass {
  constructor($uibModal, $uibModalStack, $rootScope) {
    'ngInject';
    super({$uibModal, $uibModalStack, $rootScope});

    this.modalRegister = {};
  }

  registerWithHtml(key, content, actions, options) {
    this.modalRegister[key] = {
      type: ModalTypes.Html,
      content,
      actions,
      options
    };
  }

  registerWithUrl(key, url, options) {
    this.modalRegister[key] = {
      type: ModalTypes.Url,
      url,
      options
    };
  }

  open(key) {
    const modal = this.modalRegister[key];
    if (modal) {
      switch (modal.type) {
        case ModalTypes.Url:
          return this.openUrl(modal);
        case ModalTypes.Html:
          return this.openHtml(modal);
      }
    }
  }

  openUrl(modal) {
    if (!modal) {
      throw new Error('Missing model argument')
    }

    const options = this.baseOptions(modal);
    options.templateUrl = modal.url;

    return this.openModalWithResult(modal, options);
  }

  openHtml(modal) {
    if (!modal) {
      throw new Error('Missing model argument')
    }

    const options = this.baseOptions(modal);

    //build the template with transcluded html
    options.template =
      `
      <ng1-modal>
        <content>
          ${modal.content[0].innerHTML}
        </content>
        <actions>
          ${modal.actions[0].innerHTML}
        </actions>
      </ng1-modal>
    `;

    return this.openModalWithResult(modal, options);
  }

  openModalWithResult(modal, options) {
    // Open the modal and store the result promise
    const result = this.$uibModal.open(options).result;

    let {onSuccess, onDismiss, onDissmiss} = modal.options;

    // fix for typo to be backward compatible
    if (onDissmiss && !onDismiss) {
      onDismiss = onDissmiss;
    }

    result.then(
      this.wrapResponse(onSuccess),
      this.wrapResponse(onDismiss)
    );

    return result;
  }

  wrapResponse(response) {
    return (data) => {
      if (response) {
        response(data);
        return data;
      }
    };
  }

  baseOptions(modal) {
    //parent scope
    const modalScope = (modal.options.scope || this.$rootScope).$new();

    modalScope.confirmTitle = modalScope.confirmTitle || 'app.confirmation.title';
    modalScope.confirmBody = modalScope.confirmBody || 'app.confirmation.body';
    modalScope.confirmDismiss = modalScope.confirmDismiss || 'app.confirmation.dismiss';
    modalScope.confirmOk = modalScope.confirmOk || 'app.confirmation.ok';

    //add modal instance to the scope, so one can use it in the modals html like $modal.close()
    const controller = ($uibModalInstance) => {
      'ngInject';
      modalScope.$modal = $uibModalInstance;
    };

    return angular.extend({}, modal.options, {
      scope: modalScope,
      controller,
      windowClass: [modal.options.fullscreen ? 'fullscreen' : ''].concat([modal.options.modalClass]).join(' ')
    });
  }

  dismissAll() {
    this.$uibModalStack.dismissAll();
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-modal/src/modal.declaration.service.js